import { render } from "./LoadingLayout.vue?vue&type=template&id=db2062c0&ts=true&lang=html"
import script from "./LoadingLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./LoadingLayout.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__